module.exports = __webpack_public_path__ + "img/sy_19.711ebb3f.png";